export const BACKEND_URL = "http://backend.desertsdropshipper.com/api/v1";
export const BACKENDImage_URL = "http://backend.desertsdropshipper.com/";
// export const BACKEND_URL = "http://localhost:5000/api/v1";
// export const BACKENDImage_URL = "http://localhost:5000/";
// export const BACKEND_URL = "http://192.168.0.119:5000"
// export const BACKEND_URL = "https://stbackend.softsyncdev.work";
// export const BACKEND_URL = "https://api.sumairatariq.com";
// export const BACKEND_URL = "http://192.168.0.100:5000";